// src/components/profile/theme/ThemePreview.tsx
import React from "react";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import HomeIcon from "@mui/icons-material/Home";
import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import ViewListIcon from "@mui/icons-material/ViewList";
import ImportContactsIcon from "@mui/icons-material/ImportContacts";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import { Theme } from "../types/profile";
import CommonButtons from "../../../components/CommonButtons";
import { colorOptions, fontOptions } from "./themeConstants";

interface ThemePreviewProps {
  theme: Theme;
  logo: string;
  userName: string;
  businessName: string;
}

const ICONS = [
  { Component: HomeIcon, name: "Home" },
  { Component: DashboardRoundedIcon, name: "Dashboard" },
  { Component: ViewListIcon, name: "Orders" },
  { Component: ImportContactsIcon, name: "Ledger" },
  { Component: SettingsSuggestIcon, name: "Settings" },
];


const ThemePreview: React.FC<ThemePreviewProps> = ({ theme, logo, userName, businessName }) => {
  
  const bgClass = theme.background_color ? colorOptions[theme.background_color] : "DodgerBlue";
  const fontClass = theme.font_family ? fontOptions[theme.font_family] : "Sans-serif";
  return (
    <div className="flex justify-center">
      <div className="w-full max-w-sm border border-gray-300 rounded-lg overflow-hidden shadow-lg">
        <header className={`flex justify-between items-center px-3 py-2 ${bgClass} ${fontClass}`}>
          {/* <div className="logo-container rounded-lg w-14 h-12">
            <Logo />
          </div> */}
          <p className="font-medium">{businessName}</p>
          <div className="flex items-center bg-white bg-opacity-40 rounded-lg px-2 py-1 text-sm">
            <AccountCircleIcon className="mr-1" />
            {userName}
            <ArrowDropDownIcon />
          </div>
        </header>

        <div className="flex h-64">
          <div className="w-14 bg-gray-100 flex flex-col items-center pt-4 space-y-4">
            {ICONS.map(({ Component, name }) => (
              <Component key={name} className={`cursor-pointer p-1 rounded hover:bg-gray-200 ${bgClass} ${fontClass}`} />
            ))}
          </div>

          <div className="flex-1 bg-white p-4 flex flex-col justify-between">
            <div className="space-y-3">
              <p className={`text-sm ${fontClass}`}>Font theme:</p>
              <p className={`text-sm ${fontClass}`}>This is a font style preview</p>
            </div>
            <div className="flex gap-2 justify-end">
              <CommonButtons label="CANCEL" variant="outlineDanger" className="text-xs px-3 py-1 rounded-full border-2"/>
              <CommonButtons label="CONFIRM" className="text-xs px-3 py-1 rounded-full border-2"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThemePreview;
